webpackJsonp([3],{

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-polyfill/lib/index.js
var lib = __webpack_require__("j1ja");
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/vuetify/dist/vuetify.js
var vuetify = __webpack_require__("3EgV");
var vuetify_default = /*#__PURE__*/__webpack_require__.n(vuetify);

// EXTERNAL MODULE: ./node_modules/vue-introjs/dist/index.min.js
var index_min = __webpack_require__("TQE0");
var index_min_default = /*#__PURE__*/__webpack_require__.n(index_min);

// EXTERNAL MODULE: ./node_modules/@mdi/font/css/materialdesignicons.css
var materialdesignicons = __webpack_require__("csSS");
var materialdesignicons_default = /*#__PURE__*/__webpack_require__.n(materialdesignicons);

// EXTERNAL MODULE: ./src/assets/iconosVidaSoftware-v1.0/style.css
var style = __webpack_require__("cKcr");
var style_default = /*#__PURE__*/__webpack_require__.n(style);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//
//
//

/* harmony default export */ var App = ({
  name: 'app'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a794e38","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('v-app',[_c('router-view')],1)],1)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./src/App.vue
function injectStyle (context) {
  __webpack_require__("Qi+p")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  App,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_App = (Component.exports);

// EXTERNAL MODULE: ./src/router/index.js
var router = __webpack_require__("YaEn");

// CONCATENATED MODULE: ./src/main.js


// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.









__webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "7zck"));
__webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, "18/U"));

vue_esm["default"].use(index_min_default.a);
vue_esm["default"].use(vuetify_default.a);

vue_esm["default"].config.productionTip = false;

/* eslint-disable no-new */
new vue_esm["default"]({
  vuetify: new vuetify_default.a(),
  el: '#app',
  router: router["default"],
  template: '<App/>',
  components: { App: src_App },
  icons: { iconosVidaSoftware: style_default.a // default - only for display purposes
  } });

/*
Strategio-over-loaded: Debe tener una configuración inicial configurable para poder generar:
  * NORMAL: Visualizador + favoritos + tutorial
  * GLOBAL: NORMAL + ACCESO A TODOS LOS REPORTES
  * SUPERVISOR: GLOBAL + Modulo de supervision de datos
  * ADMIN: SUPERVISOR + Herramientas administrativas
  * DEMO: GLOBAL + aviso de versión de prueba + login automático - logout - Opciones de usuario(cerrar sesión y cambiar password, nombre y cargo)

Nucleos principales:
  - folder-list
  - folder-list-item
  - report-list
  - report-list-item (add to favorite)
  - report-list-item-show (add to favorite)
  - report-list-item-show-list
  - favorite-list
  - favorite-item
  - user-login(switch: auto)
  - strategio-header(includes openPanel(), logo, tutorial)

Núcleos administrativos:
  - folder-list-options
  - folder-list-item-options
  - report-list-options
  - report-list-item-options
  - user-options:
    NORMAL and GLOBAL: panel, show: Mi cuenta, tutorial, cerrar sesion
    ADMIN: (NORMAL and GLOBAL) + administrar*
    * administrar: admin user config, reports meta-data, reports access, enable/disable users, change user type

Tutorial:
  1. Grabs the first folder with a report inside (from caché) and start the tutorial
*/

/***/ }),

/***/ "Qi+p":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YaEn":
/***/ (function(module, exports) {

throw new Error("Module build failed: TypeError: Cannot read property 'range' of null\n    at SourceCode.getTokenBefore (D:\\app\\nodejs\\strategio-client-omni-2\\node_modules\\eslint\\lib\\token-store\\index.js:303:18)\n    at checkSpacingBefore (D:\\app\\nodejs\\strategio-client-omni-2\\node_modules\\eslint\\lib\\rules\\template-curly-spacing.js:52:42)\n    at TemplateElement (D:\\app\\nodejs\\strategio-client-omni-2\\node_modules\\eslint\\lib\\rules\\template-curly-spacing.js:117:17)\n    at D:\\app\\nodejs\\strategio-client-omni-2\\node_modules\\eslint\\lib\\util\\safe-emitter.js:47:58\n    at Array.forEach (<anonymous>)\n    at Object.emit (D:\\app\\nodejs\\strategio-client-omni-2\\node_modules\\eslint\\lib\\util\\safe-emitter.js:47:38)\n    at NodeEventGenerator.applySelector (D:\\app\\nodejs\\strategio-client-omni-2\\node_modules\\eslint\\lib\\util\\node-event-generator.js:251:26)\n    at NodeEventGenerator.applySelectors (D:\\app\\nodejs\\strategio-client-omni-2\\node_modules\\eslint\\lib\\util\\node-event-generator.js:280:22)\n    at NodeEventGenerator.enterNode (D:\\app\\nodejs\\strategio-client-omni-2\\node_modules\\eslint\\lib\\util\\node-event-generator.js:294:14)\n    at CodePathAnalyzer.enterNode (D:\\app\\nodejs\\strategio-client-omni-2\\node_modules\\eslint\\lib\\code-path-analysis\\code-path-analyzer.js:608:23)\n    at Traverser.enter [as _enter] (D:\\app\\nodejs\\strategio-client-omni-2\\node_modules\\eslint\\lib\\linter.js:865:28)\n    at Traverser._traverse (D:\\app\\nodejs\\strategio-client-omni-2\\node_modules\\eslint\\lib\\util\\traverser.js:132:14)\n    at Traverser._traverse (D:\\app\\nodejs\\strategio-client-omni-2\\node_modules\\eslint\\lib\\util\\traverser.js:144:34)\n    at Traverser._traverse (D:\\app\\nodejs\\strategio-client-omni-2\\node_modules\\eslint\\lib\\util\\traverser.js:147:30)\n    at Traverser._traverse (D:\\app\\nodejs\\strategio-client-omni-2\\node_modules\\eslint\\lib\\util\\traverser.js:144:34)\n    at Traverser._traverse (D:\\app\\nodejs\\strategio-client-omni-2\\node_modules\\eslint\\lib\\util\\traverser.js:147:30)");

/***/ }),

/***/ "cKcr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "csSS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.3d7eaaf0c35b73fc3f98.js